module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-1@2x.2a828f55.jpg";